module.exports = __webpack_public_path__ + "static/media/startChallenge.4aacd536.svg";